import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const { t, language, dir } = useLanguage();

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-dark text-[#F2EBEB] arabesque-pattern" dir={dir} data-testid="footer">
      <div className="max-w-7xl mx-auto section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <h3 className="font-heading text-3xl font-light tracking-tight">
                Nûr <span className="text-primary">Events</span>
              </h3>
            </Link>
            <p className="font-body text-[#9E8E8E] leading-relaxed mb-6 max-w-md">
              {t('footer.tagline')}
            </p>
            <div className="space-y-3">
              <a href="tel:+237653989061" className="flex items-center gap-3 text-[#9E8E8E] hover:text-primary transition-colors">
                <Phone className="w-4 h-4" />
                <span className="font-body text-sm">+237 653 989 061</span>
              </a>
              <a href="mailto:contact@nurevents.com" className="flex items-center gap-3 text-[#9E8E8E] hover:text-primary transition-colors">
                <Mail className="w-4 h-4" />
                <span className="font-body text-sm">contact@nurevents.com</span>
              </a>
              <div className="flex items-center gap-3 text-[#9E8E8E]">
                <MapPin className="w-4 h-4" />
                <span className="font-body text-sm">Douala, Cameroon</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-medium mb-6 text-secondary">{t('footer.services')}</h4>
            <ul className="space-y-3">
              {['weddings', 'corporate', 'concierge', 'retreats', 'protocol'].map((service) => (
                <li key={service}>
                  <a href="/#services" className="font-body text-sm text-[#9E8E8E] hover:text-primary transition-colors">
                    {language === 'fr' ? {
                      weddings: 'Mariages',
                      corporate: 'Événements Corporate',
                      concierge: 'Conciergerie',
                      retreats: 'Retraites',
                      protocol: 'Protocole',
                    }[service] : language === 'ar' ? {
                      weddings: 'الأعراس',
                      corporate: 'فعاليات الشركات',
                      concierge: 'الكونسيرج',
                      retreats: 'الخلوات',
                      protocol: 'البروتوكول',
                    }[service] : {
                      weddings: 'Weddings',
                      corporate: 'Corporate Events',
                      concierge: 'Concierge',
                      retreats: 'Retreats',
                      protocol: 'Protocol',
                    }[service]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-lg font-medium mb-6 text-secondary">{t('footer.company')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="/#about" className="font-body text-sm text-[#9E8E8E] hover:text-primary transition-colors">
                  {t('nav.about')}
                </a>
              </li>
              <li>
                <a href="/#gallery" className="font-body text-sm text-[#9E8E8E] hover:text-primary transition-colors">
                  {t('nav.gallery')}
                </a>
              </li>
              <li>
                <a href="/#contact" className="font-body text-sm text-[#9E8E8E] hover:text-primary transition-colors">
                  {t('nav.contact')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-sm text-[#9E8E8E]">
            © {currentYear} Nûr Events. {t('footer.rights')}.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-body text-sm text-[#9E8E8E] hover:text-primary transition-colors">
              {t('footer.privacy')}
            </a>
            <a href="#" className="font-body text-sm text-[#9E8E8E] hover:text-primary transition-colors">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
